module.exports = __webpack_public_path__ + "static/media/zing-icon.6ac33b9d.svg";